module.exports = __webpack_public_path__ + "media/images/lp_v6_reserve_bg-54a24b7f8ea64aad09efd4b0fe1e7e22.webp";